import { brandSearchProductsFromBrandFilters } from "@faire/retailer-shared/search/brandLeanProductTilesRequest";
import searchProductsFromBrandFilters from "@faire/web-api/api/v2/search/products/from-brand/filters/post";
import { getQueryKey_escape_hatch as getQueryKeySearchProductsFromBrandFilters } from "@faire/web-api/api/v2/search/products/from-brand/filters/post-hooks";
import { IFilterSection } from "@faire/web-api/indigofair/data/IFilterSection";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { STALE_TIME } from "../consts";

interface IBRandFilterSectionsData {
  brandToken: string;
}
export const useBrandFilterSectionsData = ({
  brandToken,
}: IBRandFilterSectionsData) => {
  const filtersRequest = brandSearchProductsFromBrandFilters(brandToken);

  const { data: brandProductFiltersData } = useQuery({
    queryKey: getQueryKeySearchProductsFromBrandFilters(filtersRequest),
    queryFn: () => searchProductsFromBrandFilters(filtersRequest),
    placeholderData: keepPreviousData,
    staleTime: STALE_TIME,
  });

  const filterSections = brandProductFiltersData?.filter_sections;

  const categoryFilterOptions =
    filterSections?.find(
      ({ field_name }) => field_name === IFilterSection.FieldName.CATEGORY
    )?.options ?? null;

  return { filterSections, categoryFilterOptions };
};
